"use client";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";
import { IconLove } from "./iconLove";
import { useLoveStore } from "@/lib/store/love.store";
import React, { useEffect, useState } from "react";
import { message } from "antd";

export default function HoverIcon({ className = "", AddCart, BuyBow, product = "" as any }) {
	const [isLove, setIsLove] = useState(false);

	const { loveIds, setLoveProducts } = useLoveStore();
	useEffect(() => {
		if (loveIds.length && product?.id) {
			setIsLove(loveIds.includes(product.id));
		} else {
			setIsLove(false);
		}
	}, [loveIds]);

	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = product?.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<div
			className={`hovericon absolute !right-[12px] top-0 z-[3] flex  flex-col items-center justify-start gap-2 pt-[20px] font-abeezee opacity-0 transition-all  duration-500 group-hover:!right-0 group-hover:opacity-100 ${className}`}
		>
			{/* <div
				className=" tooltip-icon right-3 !flex h-[35px] w-[35px] !items-center !justify-center rounded-full bg-black opacity-60"
				onClick={addOrDelLike}
			>
				<i
					className={` ri-heart-add-line text-[22px] text-white opacity-90 ${
						isLove == true ? "!text-red-500" : ""
					}`}
				></i>
				<span className={`tooltip-text absolute ${isLove == true ? "!text-red-500" : ""}`}>
					{isLove == true ? "Remove" : "Add To Wishlist"}
				</span>
			</div> */}
			<div
				className=" tooltip-icon right-3 !flex h-[35px] w-[35px] !items-center !justify-center rounded-full bg-black opacity-60"
				onClick={AddCart}
			>
				<i className="ri-shopping-cart-2-line text-[22px] text-white opacity-90"></i>
				<span className="tooltip-text absolute ">Add To Cart</span>
			</div>
			<div
				className=" tooltip-icon right-3 !flex h-[35px] w-[35px] !items-center !justify-center rounded-full bg-black opacity-60"
				onClick={BuyBow}
			>
				<i className="ri-shopping-bag-2-line text-[22px]  text-white opacity-90"></i>
				<span className="tooltip-text absolute ">Quick Buy</span>
			</div>
		</div>
	);
}
